import React from "react";
import { SVG, IconProps } from "../SVG";

const DEFAULT_SIZE = 24;
export const CaretRight = ({ size = DEFAULT_SIZE, color = "#212121", ...props }: IconProps) => (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        size={size}
        color={color}
        {...props}
    >
        <path
            fill="currentColor"
            d="M9 17.898c0 1.074 1.265 1.648 2.073.94l6.31-5.521a1.75 1.75 0 0 0 0-2.634l-6.31-5.522C10.265 4.454 9 5.028 9 6.101v11.797Z"
        />
    </SVG>
);
CaretRight.displayName = "CaretRight";
